import { Component, OnInit } from '@angular/core';
import { SearchDataService } from '../service/search-data.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  searchKey: string;
  searchPlaceholder: string;

  constructor(private searchService: SearchDataService) { }

  ngOnInit() {
    this.searchService.currentSearchPlaceholder.subscribe(data => {
      if (data && data.length > 0) {
        this.searchPlaceholder = data;
        this.searchKey=null;
      }
    });
  }

  search() {
    console.log("search clicked!");
    if(this.searchKey == undefined || this.searchKey == null || this.searchKey.trim().length <= 0) return;
    this.searchService.searchForData(this.searchKey.trim());
  }

}
